import { UserStatistics } from "../../../models/Statistics";

export const REQUEST_USERSTATISTICS = "REQUEST_USERSTATISTICS";
export const REQUEST_USERSTATISTICS_DONE = "REQUEST_USERSTATISTICS_DONE";

export interface FetchUserStatistics {
  type: typeof REQUEST_USERSTATISTICS;
  payload: ReadonlyArray<UserStatistics>;
}

export interface FetchUserStatisticsDone {
  type: typeof REQUEST_USERSTATISTICS_DONE;
  payload: ReadonlyArray<UserStatistics>;
}

export interface UsersStatisticsState {
  isLoading: boolean;
  userStatistics: ReadonlyArray<UserStatistics>;
}

export type UserStatisticsActions =
  | FetchUserStatistics
  | FetchUserStatisticsDone;
